import type { LoaderParams } from "~/components/abstracts/Image/loader"

export const HOSTNAME = "i.vimeocdn.com"

export default function imageLoader({ src, width }: LoaderParams) {
  return `${src}_${width}`
}
